module.exports = __webpack_public_path__ + "static/media/60010.55cbf42a.png";